<script generics="Item extends { id: string }">
  import { SvelteSet } from 'svelte/reactivity'
  import { tick } from 'svelte'

  import Symbol from '$lib/Symbol.svelte'

  /**
   * @type {{
   *   items: Item[],
   *   name?: string,
   *   summary: Svelte.Snippet<[Item, { open: boolean }]>,
   *   content: Svelte.Snippet<[Item, { open: boolean }]>
   * }}
   */
  let { items, name, summary, content } = $props()

  const opened = new SvelteSet()
  let animating = $state()

  const toggle = async (el, id) => {
    // Measure hieght before toggle
    const before = el.getBoundingClientRect()

    // Toggle open state to update DOM
    const next = !el.open
    el.open = next
    if (next) {
      opened.add(id)
    } else {
      opened.delete(id)
    }

    // Wait for layout to settle
    await tick()

    // Measure height in target state
    const after = el.getBoundingClientRect()

    // Force open state while animating
    el.open = true

    // Animate height change
    animating = id
    const animation = el.animate(
      [{ height: `${before.height}px` }, { height: `${after.height}px` }],
      { duration: 350, easing: 'cubic-bezier(0.22, 1, 0.36, 1)' }
    )

    // Wait for animation to finish
    await animation.finished

    // Commit change
    animating = null
    el.open = next
  }

  const onclick = (item) => (event) => {
    const el = event.currentTarget.closest('details')
    toggle(el, item.id)
    el.focus()
    event.preventDefault()
  }
</script>

<div class="accordion">
  {#each items as item (item.id)}
    {@const open = opened.has(item.id)}
    <details
      {name}
      class="item"
      class:open
      class:animating={animating === item.id}>
      <summary class="summary" onclick={onclick(item)}>
        <span class="chevron">
          <Symbol name="chevron" size="md" />
        </span>
        <span>{@render summary(item, { open })}</span>
      </summary>
      {@render content(item, { open })}
    </details>
  {/each}
</div>

<style>
  .accordion {
    display: flex;
    flex-direction: column;
    margin: -0.25rem 0;
  }

  .item.animating {
    overflow-y: hidden;
  }

  .item:not(:last-child) {
    border-bottom: 1px solid rgba(var(--rgb-gray), 0.25);
  }

  .item:not(:last-child).open {
    padding-bottom: 1rem;
  }

  .summary {
    display: flex;
    align-items: flex-start;
    gap: 0.25rem;
    padding: 0.75rem 0;
    cursor: pointer;

    &::-webkit-details-marker {
      display: none;
    }

    &::marker {
      display: none;
    }
  }

  .chevron {
    --current-color: rgb(var(--rgb-muted));

    position: relative;
    top: 0.05rem; /* Align with text */
    transform: rotate(-90deg);
    transition: transform 350ms cubic-bezier(0.22, 1, 0.36, 1);
  }

  .item.open .chevron {
    transform: rotate(0deg);
  }
</style>
